import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTasks = (
    backend: string,
    token: string
) => {
    return fetch(
        `${getApiUrl(backend)}get_all_active_tasks`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTasks;
